/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { EmailCaptureForm } from "@/components/landing/email-capture-form";
import { useState } from "react";

export function TemplateDownload({ templateName }: { templateName: string }) {
  const [unlocked, setUnlocked] = useState(false);

  if (unlocked) {
    return (
      <div className="rounded-lg border border-secondary/20 bg-secondary/10 p-6 text-center">
        <p className="text-sm font-medium text-foreground">
          Check your email for the download link!
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          We&apos;ve sent the {templateName} to your inbox.
        </p>
      </div>
    );
  }

  return (
    <div className="card-premium p-6">
      <h3 className="text-lg font-semibold text-foreground">
        Download {templateName}
      </h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Enter your email to get the free template.
      </p>
      <div className="mt-4">
        <EmailCaptureForm
          source="email_capture"
          buttonText="Get Free Template"
          successMessage="Template sent! Check your email."
          variant="stacked"
          onSuccess={() => setUnlocked(true)}
        />
      </div>
    </div>
  );
}
